<mat-card id="case-detailed-results-editable">
    <mat-card-content *ngIf="result">

        <!-- FIRST ROW -->
        <div class="row">

            <!-- FIRST ROW - FIRST COLUMN - OVERVIEW -->
            <div class="col-sm-4">
                <div class="row no-gutters mb-2">
                    <div class="col-12">
                        <div class="smp-title"> {{ 'detailed_processing.results.title.overview' | translate }} </div>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.delivery_date | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.delivery_date}}"
                                   matInput [matDatepicker]="pickerDeliveryDate"
                                   [(ngModel)]="result.general.delivery_date"
                                   (dateChange)="patchAndUpdateWithValue({ propertyName: 'general.delivery_date', value: dateTimeToDateString(result.general.delivery_date) })"
                                   [disabled]="disabled">
                            <mat-datepicker-toggle matSuffix [for]="pickerDeliveryDate"></mat-datepicker-toggle>
                            <mat-datepicker #pickerDeliveryDate></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.assessment_id | translate }}</mat-label>
                            <mat-select id="{{idPrefix}}{{result.general.trans.assessment_id}}"
                                        [(ngModel)]="selectedTotalLossAssessment"
                                        (ngModelChange)="updateAssessmentType()"
                                        [disabled]="disabled">
                                <mat-option *ngFor="let tlaValue of totalLossAssessmentValues"
                                            id="{{idPrefix}}{{result.general.trans.assessment_id}}.{{tlaValue.key}}"
                                            [value]="tlaValue">
                                    {{ tlaValue.trans | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.duration_repair | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.duration_repair}}"
                                   type="text" matInput
                                   [(ngModel)]="result.general.duration_repair"
                                   (blur)="patchAndUpdate('general.duration_repair')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ result.general.trans.duration_repair_unit | translate }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.duration_replacement | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.duration_replacement}}"
                                   type="text" matInput
                                   [(ngModel)]="result.general.duration_replacement"
                                   (blur)="patchAndUpdate('general.duration_replacement')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ 'common.label.days' | translate }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.deductible_fullcoverage | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.deductible_fullcoverage}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.general.deductible_fullcoverage"
                                   (blur)="patchAndUpdate('general.deductible_fullcoverage')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.deductible_partialcoverage | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.deductible_partialcoverage}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.general.deductible_partialcoverage"
                                   (blur)="patchAndUpdate('general.deductible_partialcoverage')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters mt-2">
                    <div class="col-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + result.general.trans.repair_approval + '.')"
                                            [inputLabel]="result.general.trans.repair_approval | translate"
                                            [(trueFalseNull)]="result.general.repair_approval"
                                            (trueFalseNullChange)="patchAndUpdate('general.repair_approval')"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <app-boolean-toggle [idPrefix]="(idPrefix + result.general.trans.notice_of_assignment + '.')"
                                            [inputLabel]="result.general.trans.notice_of_assignment | translate"
                                            [(trueFalseNull)]="result.general.notice_of_assignment"
                                            (trueFalseNullChange)="patchAndUpdate('general.notice_of_assignment')"
                                            class="full-width">
                        </app-boolean-toggle>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters mt-3">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.general.trans.tax_percentage | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.general.trans.tax_percentage}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.general.tax_percentage"
                                   (blur)="patchAndUpdate('general.tax_percentage')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">%</div>
                </div>
            </div>

            <!-- FIRST ROW - SECOND COLUMN - CALCULATION RESULT -->
            <div class="col-sm-4">
                <div class="row no-gutters mb-2">
                    <div class="col-12">
                        <div class="smp-title"> {{ 'detailed_processing.results.title.calculation_result' | translate }}</div>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.calculation.trans.costs_repair_net | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.costs_repair_net}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.costs_repair_net"
                                   (blur)="patchAndUpdate('calculation.costs_repair_net')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.calculation.trans.costs_repair_net}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('calculation.costs_repair_gross', 'calculation.costs_repair_net')"
                                    [disabled]="!result.general.tax_percentage || !result.calculation.costs_repair_net">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.GROSS, result.calculation.costs_repair_net, result.calculation.costs_repair_gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.costs_repair_tax | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.costs_repair_tax}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.costs_repair_tax"
                                   (blur)="patchAndUpdate('calculation.costs_repair_tax')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.calculation.trans.costs_repair_gross | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.costs_repair_gross}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.costs_repair_gross"
                                   (blur)="patchAndUpdate('calculation.costs_repair_gross')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.calculation.trans.costs_repair_gross}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('calculation.costs_repair_net', 'calculation.costs_repair_gross')"
                                    [disabled]="!result.general.tax_percentage || !result.calculation.costs_repair_gross">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.NET, result.calculation.costs_repair_net, result.calculation.costs_repair_gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.deductions | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.deductions}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.deductions"
                                   (blur)="patchAndUpdate('calculation.deductions')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.appreciation | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.appreciation}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.appreciation"
                                   (blur)="patchAndUpdate('calculation.appreciation')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.calculation.trans.claims_amount_net | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.claims_amount_net}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.claims_amount_net"
                                   (blur)="patchAndUpdate('calculation.claims_amount_net')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.calculation.trans.claims_amount_net}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('calculation.claims_amount_gross', 'calculation.claims_amount_net')"
                                    [disabled]="!result.general.tax_percentage || !result.calculation.claims_amount_net">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.GROSS, result.calculation.claims_amount_net, result.calculation.claims_amount_gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.claims_amount_tax | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.claims_amount_tax}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.claims_amount_tax"
                                   (blur)="patchAndUpdate('calculation.claims_amount_tax')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.calculation.trans.claims_amount_gross | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.claims_amount_gross}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.claims_amount_gross"
                                   (blur)="patchAndUpdate('calculation.claims_amount_gross')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.calculation.trans.claims_amount_gross}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('calculation.claims_amount_net', 'calculation.claims_amount_gross')"
                                    [disabled]="!result.general.tax_percentage || !result.calculation.claims_amount_gross">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.NET, result.calculation.claims_amount_net, result.calculation.claims_amount_gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.reduced_market_value_assessor | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.calculation.trans.reduced_market_value_assessor}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.calculation.reduced_market_value_assessor"
                                   (blur)="patchAndUpdate('calculation.reduced_market_value_assessor')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.calculation.trans.comment | translate }}</mat-label>
                            <textarea id="{{idPrefix}}{{result.calculation.trans.comment}}"
                                      matInput
                                      rows="3"
                                      [(ngModel)]="result.calculation.comment"
                                      (blur)="patchAndUpdate('calculation.comment')"
                                      [disabled]="disabled">
                                </textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>


            </div>

            <!-- FIRST ROW - THIRD COLUMN - VALUATION RESULT  -->
            <div class="col-sm-4">
                <div class="row no-gutters mb-2">
                    <div class="col-12">
                        <div class="smp-title"> {{ 'detailed_processing.results.title.valuation_result' | translate }} </div>
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.valuation.trans.valuation_type | translate }}</mat-label>
                            <mat-select id="{{idPrefix}}{{result.valuation.trans.valuation_type}}"
                                        [(ngModel)]="selectedValuationType"
                                        (ngModelChange)="updateValuationType()"
                                        [disabled]="disabled">
                                <mat-option>{{ 'common.label.empty_dropdown_option' | translate }}</mat-option>
                                <mat-option *ngFor="let valuationType of valuationResultTypeValues"
                                            id="{{idPrefix}}{{result.valuation.trans.valuation_type}}.{{valuationType.key}}"
                                            [value]="valuationType">
                                    {{ valuationType.trans | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.valuation.trans.tax_type_id | translate }}</mat-label>
                            <mat-select id="{{idPrefix}}{{result.valuation.trans.tax_type_id}}"
                                        [(ngModel)]="selectedValuationTaxType"
                                        (ngModelChange)="updateTaxationType()"
                                        [disabled]="disabled">
                                <mat-option>{{ 'common.label.empty_dropdown_option' | translate }}</mat-option>
                                <mat-option *ngFor="let taxType of valuationResultTaxTypes"
                                            id="{{idPrefix}}{{result.valuation.trans.tax_type_id}}.{{taxType.key}}"
                                            [value]="taxType">
                                    {{ taxType.trans | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.valuation.trans.net | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.valuation.trans.net}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.valuation.net"
                                   (blur)="patchAndUpdate('valuation.net')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.valuation.trans.net}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('valuation.gross', 'valuation.net')"
                                    [disabled]="!result.general.tax_percentage || !result.valuation.net">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.GROSS, result.valuation.net, result.valuation.gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.valuation.trans.tax | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.valuation.trans.tax}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.valuation.tax"
                                   (blur)="patchAndUpdate('valuation.tax')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width with-calc-button">
                            <mat-label>{{ result.valuation.trans.gross | translate }}</mat-label>
                            <input id="{{idPrefix}}{{result.valuation.trans.gross}}"
                                   type="text" matInput currency
                                   [(ngModel)]="result.valuation.gross"
                                   (blur)="patchAndUpdate('valuation.gross')"
                                   [disabled]="disabled">
                            <button id="{{idPrefix}}{{result.valuation.trans.gross}}.btn.calculate"
                                    mat-button
                                    matSuffix mat-icon-button
                                    (click)="calculate('valuation.net', 'valuation.gross')"
                                    [disabled]="!result.general.tax_percentage || !result.valuation.gross">
                                <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.NET, result.valuation.net, result.valuation.gross) | translate">
                                    <i class="fas fa-calculator"></i>
                                </mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ result.valuation.trans.comment | translate }}</mat-label>
                            <textarea id="{{idPrefix}}{{result.valuation.trans.comment}}"
                                      matInput
                                      rows="3"
                                      [(ngModel)]="result.valuation.comment"
                                      (blur)="patchAndUpdate('valuation.comment')"
                                      [disabled]="disabled">
                            </textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-2"></div>
                </div>

            </div>
        </div>


        <!-- SECOND ROW - TITLE ONLY -->
        <div class="row mt-3">
            <div class="col">
                <div class="row no-gutters">
                    <div class="col-12">
                        <div class="smp-title"> {{ 'detailed_processing.results.title.further_results' | translate }} </div>
                    </div>
                </div>

                <div class="row no-gutters mb-2">
                    <div class="col-12 text-right">
                        <a id="{{idPrefix}}btn.add_further_result"
                           mat-stroked-button
                           color="accent"
                           class="add-btn"
                           [ngClass]="{'disabled': disabled || filteredResultTypes.length === 0 || result.additions.length >= 8 }"
                           (click)="addFurtherResults()"
                           [disabled]="disabled">
                            {{ 'detailed_processing.results.button.add_further_results' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- THIRD ROW - FURTHER RESULTS  -->
        <div class="row">

            <div class="col-sm-4" *ngFor="let furtherResult of result.additions; let idx = index">
                <results-further #furtherResultCmp
                                 [idPrefix]="(idPrefix + 'further_result_' + idx + '.')"
                                 [bananaBox]="furtherResult"
                                 [allResultTypes]="resultTypes"
                                 [availableResultTypes]="filteredResultTypes"
                                 [vehicleTaxPercentage]="result.general.tax_percentage"
                                 (bananaBoxChange)="updateFurtherResult($event)"
                                 (remove)="removeFurtherResult($event)"
                                 [disabled]="disabled">
                </results-further>
            </div>

        </div>

    </mat-card-content>
</mat-card>
